import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Link} from "react-router-dom";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const CatList = () => {
    const { cat_id } = useParams();

    const [articles, setArticles] = useState([]);
    useEffect(() => {
        loadUsers();
    },
        [cat_id]
    )
    const loadUsers = async () => {
        const result = await axios.get("https://acesoftech.co.in/tanzil/ecomAPI/tanzil_blog/articles/articles_list.php?cat_id=" + cat_id)
        setArticles(result.data.records);
        console.log(result.data)
    }

    return (
        <div>
            {articles.map((articles, index) => (
                <div class="card card-horizontal">
                    <div class="card-body">
                        <div class="card-horizontal-left">
                            <div class="card-category">
                                </div>
                            <h3 class="card-title"><Link  to={`/articles/${articles.id}`}>{articles.articles_name}</Link></h3>
                            <div class="card-excerpt">
                                <p>{articles.articles_description}</p>
                                <p><Link  to={`/articles/${articles.id}`}>Read More</Link></p>
                            </div>
                        </div>
                        
                        <div class="card-horizontal-right">
                        <Link  to={`/articles/${articles.id}`} class="card-featured-img"><img  src={'https://acesoftech.co.in/tanzil/ecomAPI/tanzil_blog/images/' + articles.image} height="50" width="50" /></Link>
                            {/* <a class="card-featured-img" href="single-post.html"></a> */}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default CatList